import React from 'react';
import { confirmAlert } from 'react-confirm-alert';

interface CustomConfirmUIProps {
  title: string;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const CustomConfirmUI: React.FC<CustomConfirmUIProps> = ({
  title,
  message,
  onClose,
  onConfirm,
}) => {
  return (
    <div className="p-6 bg-base-100 border-2 border-primary rounded-lg shadow-lg">
      <h1 className="text-xl font-bold text-base-content">{title}</h1>
      <p className="text-base-content my-4">{message}</p>
      <div className="flex justify-end space-x-4">
        <button
          onClick={() => {
            onConfirm();
            onClose();
          }}
          className="btn btn-primary"
        >
          Yes
        </button>
        <button onClick={onClose} className="btn btn-outline btn-primary">
          No
        </button>
      </div>
    </div>
  );
};

export const showOperationConfirmation = (
  title: string,
  message: string,
  callback: () => void,
) => {
  confirmAlert({
    title: title,
    message: message,
    customUI: ({ title, message, onClose }): React.ReactNode => {
      return (
        <CustomConfirmUI
          title={title}
          message={message}
          onClose={onClose}
          onConfirm={callback}
        />
      );
    },
  });
};
